var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerBeyond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xED\x8C\x8C\xEB\xB9\x84\xEC\x9A\x98\xEB\x93\x9C\xEB\xB2\xA8\xEB\xB8\x8C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2604 5H22.0729C23.6251 5 24.8854 6.26024 24.8854 7.8125L16.4479 7.8125C16.4479 6.26024 17.7081 5 19.2604 5Z",
    fill: "#445EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.2395 7.8125H15.0937C13.2528 7.8125 11.7604 9.30488 11.7604 11.1458V31.6667C11.7604 33.5076 13.2528 35 15.0937 35H26.2395C28.0805 35 29.5729 33.5076 29.5729 31.6667V11.1458C29.5729 9.30488 28.0805 7.8125 26.2395 7.8125Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.6667 32.7083C24.176 32.7083 27.0208 29.8635 27.0208 26.3542C27.0208 22.8449 24.176 20 20.6667 20C17.1574 20 14.3125 22.8449 14.3125 26.3542C14.3125 29.8635 17.1574 32.7083 20.6667 32.7083Z",
    fill: "#505363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.2292 30.1584L24.812 28.5396C25.1569 27.8868 25.3541 27.1439 25.3541 26.3542C25.3541 23.7654 23.2555 21.6667 20.6666 21.6667C18.0778 21.6667 15.9791 23.7654 15.9791 26.3542C15.9791 28.9431 18.0778 31.0417 20.6666 31.0417C21.5532 31.0417 22.3791 30.7911 23.0861 30.3635L24.3482 31.8051C24.7815 32.3001 25.5341 32.3501 26.0291 31.9168L26.1175 31.8394C26.6125 31.406 26.6625 30.6534 26.2292 30.1584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.6666 29.1667C22.2199 29.1667 23.4791 27.9075 23.4791 26.3542C23.4791 24.8009 22.2199 23.5417 20.6666 23.5417C19.1133 23.5417 17.8541 24.8009 17.8541 26.3542C17.8541 27.9075 19.1133 29.1667 20.6666 29.1667Z",
    fill: "#505363"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerBeyond);
export default __webpack_public_path__ + "static/media/power-beyond.fc4afebfecf9a49a963ab6eeabc73446.svg";
export { ForwardRef as ReactComponent };